import {
  Activity,
  AppWindow,
  BarChart3,
  Bot,
  Boxes,
  BriefcaseBusiness,
  Building2,
  Car,
  Code2,
  Compass,
  DatabaseZap,
  GraduationCap,
  HeartHandshake,
  LineChart,
  Megaphone,
  MessageCircle,
  MonitorSmartphone,
  Paintbrush,
  PenTool,
  Phone,
  Search,
  ServerCog,
  Settings2,
  ShieldCheck,
  ShoppingBag,
  ShoppingCart,
  Sparkles,
  Store,
  TabletSmartphone,
  UserRoundSearch,
  Video,
  Smartphone,
  SmartphoneCharging,
  Gamepad2,
  ReceiptText,
} from "lucide-react";

import type {
  BlogPost,
  FAQItem,
  NavOffering,
  ServicePage,
  PortfolioProject,
} from "../types";
import { digitalSolutions } from "../data/solutions";
import { developmentServices } from "../data/services";

// Services & Solutions

export const site = {
  name: "Skand Tech Hub",
  tagline: "Design. Develop. Deploy.",
  url: "https://www.skandtechhub.com/",
  phone: "+91 92574 11966",
  whatsapp: "919257411966",
  email: "sales@skandtechhub.com",
  address:
    "C-405, 4th Floor RTech Capital Galleria, Sirsi Road, Vaishali West Rd, Kanakpura, Jaipur, Rajasthan 302034",
};

export const serviceGroups = [
  "Mobile App Development",
  "Website Development",
  "Software Development",
  "On Demand Mobile App",
] as const;

export const solutionGroups = [
  "Digital Marketing Solutions",
  "E-Commerce Solutions",
  "Custom Software Solutions",
] as const;

export const navServices: NavOffering[] = [
  {
    title: "Mobile App Development",
    slug: "mobile-app-development",
    group: "Mobile App Development",
    icon: TabletSmartphone,
  },

  {
    title: "Flutter App Development",
    slug: "flutter-app-development",
    group: "Mobile App Development",
    icon: Sparkles,
  },
  {
    title: "React Native Development",
    slug: "react-native-development",
    group: "Mobile App Development",
    icon: Smartphone,
  },

  {
    title: "Website Development",
    slug: "website-development",
    group: "Website Development",
    icon: Code2,
  },
  {
    title: "E-commerce Website Development",
    slug: "e-commerce-website-development",
    group: "Website Development",
    icon: ShoppingCart,
  },

  {
    title: "WordPress Development",
    slug: "wordpress-development",
    group: "Website Development",
    icon: Paintbrush,
  },
  {
    title: "CRM Software Development",
    slug: "crm-software-development",
    group: "Software Development",
    icon: UserRoundSearch,
  },
  {
    title: "ERP Software Development",
    slug: "erp-software-development",
    group: "Software Development",
    icon: Settings2,
  },

  {
    title: "Custom Software Development",
    slug: "custom-software-development",
    group: "Software Development",
    icon: BriefcaseBusiness,
  },
  {
    title: "Food Delivery App Development",
    slug: "food-delivery-app-development",
    group: "On Demand Mobile App",
    icon: Store,
  },

  {
    title: "Astrology App Development",
    slug: "astrology-app-development",
    group: "On Demand Mobile App",
    icon: Compass,
  },
  {
    title: "Salon App Development",
    slug: "salon-app-development",
    group: "On Demand Mobile App",
    icon: Sparkles,
  },
];

export const navSolutions: NavOffering[] = [
  {
    title: "SEO Services",
    slug: "seo-services",
    group: "Digital Marketing Solutions",
    icon: Search,
  },
  {
    title: "Social Media Optimization",
    slug: "social-media-optimization",
    group: "Digital Marketing Solutions",
    icon: MessageCircle,
  },
  {
    title: "Social Media Marketing",
    slug: "social-media-marketing",
    group: "Digital Marketing Solutions",
    icon: Megaphone,
  },
  {
    title: "ORM Services",
    slug: "orm-services",
    group: "Digital Marketing Solutions",
    icon: ShieldCheck,
  },
  {
    title: "PPC Management",
    slug: "ppc-management",
    group: "Digital Marketing Solutions",
    icon: LineChart,
  },
  {
    title: "WhatsApp Marketing",
    slug: "whatsapp-marketing",
    group: "Digital Marketing Solutions",
    icon: MessageCircle,
  },
  {
    title: "OpenCart Development",
    slug: "opencart-development",
    group: "E-Commerce Solutions",
    icon: ShoppingCart,
  },
  {
    title: "Magento Development",
    slug: "magento-development",
    group: "E-Commerce Solutions",
    icon: Store,
  },
  {
    title: "WooCommerce Development",
    slug: "woocommerce-development",
    group: "E-Commerce Solutions",
    icon: ShoppingBag,
  },
  {
    title: "Prestashop Development",
    slug: "prestashop-development",
    group: "E-Commerce Solutions",
    icon: Boxes,
  },
  {
    title: "Shopify Development",
    slug: "shopify-development",
    group: "E-Commerce Solutions",
    icon: BarChart3,
  },
  {
    title: "Billing Software Development Company",
    slug: "billing-software-development-company",
    group: "Custom Software Solutions",
    icon: ReceiptText,
  },
];

export const services = [...developmentServices];

export const solutions = [...digitalSolutions];

export const industries = [
  "Healthcare & Fitness",
  "Banking & Finance",
  "Education & eLearning",
  "Travel & Tourism",
  "E-commerce",
  "Real Estate",
  "Food Delivery",
  "Logistics & Transportation",
  "Taxi Booking",
  "On-Demand Services",
  "OTT & Media Streaming",
  "CRM & ERP Solutions",
];

export const process = [
  [
    "01",
    "Requirement Analysis",
    "We understand your business objectives, target audience, and project requirements to create a strategic development roadmap.",
  ],
  [
    "02",
    "Business Consultation",
    "Our experts provide technology consultation, define the best development approach, and recommend the right solutions for your business.",
  ],
  [
    "03",
    "UI/UX Design",
    "We create intuitive, engaging, and user-friendly designs that deliver exceptional user experiences across mobile and web platforms.",
  ],
  [
    "04",
    "Development",
    // "Our experienced developers build secure, scalable, and high-performance applications using modern technologies such as Android app development, iOS app development, Flutter app development, React Native development, hybrid app development, and website development.",
    "Our experienced developers build secure, scalable, and high-performance mobile apps and websites using modern technologies, including Android, iOS, Flutter, React Native, and hybrid development.",
  ],
  [
    "05",
    "Quality Assurance & Testing",
    "Every application undergoes rigorous testing to ensure security, performance, usability, and compatibility across devices and platforms.",
  ],
  [
    "06",
    "Deployment",
    "We deploy your application or website smoothly on the appropriate platforms while ensuring a secure and hassle-free launch.",
  ],
  [
    "07",
    "Maintenance & Support",
    "Our partnership continues after launch with regular updates, performance monitoring, security improvements, and technical support.",
  ],
] as const;

export const portfolioProjects: PortfolioProject[] = [
  {
    id: "01",
    title: "Astra Commerce OS",
    slug: "astra-commerce-os",
    category: "E-Commerce",
    summary:
      "A headless commerce platform with personalized catalogs, order workflows, and executive analytics.",
    image:
      "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?auto=format&fit=crop&w=1200&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1556741533-6e6a62bd8b49?auto=format&fit=crop&w=1200&q=80",
    ],
    technologies: ["React", "Node.js", "Shopify", "PostgreSQL"],
    results: [
      "42% faster checkout completion",
      "31% higher repeat purchase rate",
      "Unified inventory visibility across channels",
    ],
  },
  {
    id: "02",
    title: "Nexa Field Service",
    slug: "nexa-field-service",
    category: "Enterprise Software",
    summary:
      "A field operations platform with scheduling, technician apps, live job updates, and SLA dashboards.",
    image:
      "https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1200&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1200&q=80",
    ],
    technologies: ["Flutter", "Laravel", "Maps API", "MySQL"],
    results: [
      "28% fewer missed appointments",
      "Real-time technician dispatch",
      "Automated customer updates",
    ],
  },
  {
    id: "03",
    title: "Meridian CRM Cloud",
    slug: "meridian-crm-cloud",
    category: "CRM",
    summary:
      "A custom CRM for enterprise sales teams with lead scoring, pipeline forecasting, and workflow automation.",
    image:
      "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1200&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1200&q=80",
    ],
    technologies: ["React", "Node.js", "PostgreSQL", "Power BI"],
    results: [
      "38% faster lead response",
      "Pipeline forecasting for leadership",
      "Automated follow-up workflows",
    ],
  },
];

export const blogPosts: BlogPost[] = [
  {
    title: "How Enterprise Teams Should Plan Custom Software in 2026",
    slug: "enterprise-custom-software-planning",
    excerpt:
      "A practical framework for aligning business operations, product architecture, security, and measurable outcomes.",
    date: "2026-01-18",
    readTime: "7 min read",
    category: "Software Strategy",
    image:
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1200&q=80",
    sections: [
      "Successful custom software starts with operational clarity. Teams need to know which processes create leverage, where existing systems fail, and which metrics define a better workflow.",
      "A production roadmap should connect discovery, prototyping, technical architecture, release planning, analytics, and support. This reduces rework and gives leadership visibility before engineering scale increases.",
      "Security, permissions, reporting, and maintainability should be designed early. These foundations are harder to retrofit after adoption grows.",
    ],
  },
  {
    title: "What Makes a Mobile App Ready for Market",
    slug: "mobile-app-market-readiness",
    excerpt:
      "The engineering, design, analytics, and release factors that separate prototypes from real mobile products.",
    date: "2026-02-07",
    readTime: "6 min read",
    category: "Mobile Apps",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1200&q=80",
    sections: [
      "A market-ready app needs more than screens. It requires onboarding, analytics, crash monitoring, secure APIs, release processes, accessibility, and a support model.",
      "Performance has a direct impact on retention. Teams should test network failures, low-end devices, authentication edge cases, and store review requirements before launch.",
      "The strongest launches are backed by a clear post-release improvement loop that turns user behavior into product decisions.",
    ],
  },
  {
    title: "Building SEO and AEO Foundations Into Modern Websites",
    slug: "seo-aeo-modern-websites",
    excerpt:
      "How semantic content, structured data, performance, and entity clarity support search engines and AI answer engines.",
    date: "2026-03-12",
    readTime: "5 min read",
    category: "Digital Growth",
    image:
      "https://images.unsplash.com/photo-1432888622747-4eb9a8f2c293?auto=format&fit=crop&w=1200&q=80",
    sections: [
      "Modern discoverability depends on clarity. Pages should identify the company, service, audience, location context, proof, and next action without ambiguity.",
      "Structured data helps machines understand entities, services, FAQs, articles, and local business details. It should support real content instead of replacing it.",
      "Performance and accessibility also affect discovery because they shape how users and crawlers experience the site.",
    ],
  },
];

export const faqs: FAQItem[] = [
  {
    question:
      "Why choose Skand Tech Hub as your AI-driven mobile app & web development company?",
    answer:
      "Skand Tech Hub delivers AI-powered, scalable, and secure mobile apps and websites with expert developers, modern technologies, transparent communication, and dedicated support for every project.",
  },
  {
    question:
      "What mobile app development services does Skand Tech Hub provide?",
    answer:
      "We provide Android app development, iOS app development, Flutter app development, React Native development, hybrid app development, custom mobile app development, and AI app development services.",
  },
  {
    question: "Do you provide custom website development services?",
    answer:
      "Yes, we develop responsive, SEO-friendly, secure, and high-performance business websites, eCommerce websites, and custom web applications tailored to your unique business requirements.",
  },
  {
    question:
      "Which technologies does Skand Tech Hub use for app and web development?",
    answer:
      "We use Flutter, React Native, Android, iOS, React.js, Node.js, Laravel, PHP, Python, MySQL, MongoDB, and AI technologies to build scalable solutions.",
  },
  {
    question: "How can I get started with Skand Tech Hub?",
    answer:
      "Simply contact Skand Tech Hub, share your project requirements, and our experts will provide a free consultation, project roadmap, timeline, and customized development solution.",
  },
  {
    question: "Do you provide post-launch support and maintenance?",
    answer:
      "Yes, we offer ongoing maintenance, performance optimization, security updates, bug fixes, feature enhancements, and dedicated technical support to ensure your application runs smoothly.",
  },
];

export const techStack = [
  "React",
  "React Native",
  "JavaScript",
  "TypeScript",
  "Next.js",
  "Node.js",
  "Express.js",
  "Nest.js",
  "Laravel",
  "Flutter",
  "Swift",
  "Kotlin",
  "PostgreSQL",
  "AWS",
  "Firebase",
  "Shopify",
  "WordPress",
  //
  "MongoDB",
  "Docker",
  "Tailwind CSS",
  "GraphQL",
  "Python",
  "Django",
];
